<template>
  <div class="calculate-bike-size">
    <section class="relative w-full">
      <!-- Desktop screen version -->
      <div
        class="bike-size-hero-bg-section relative md:block hidden w-full overflow-hidden md:bg-center bg-no-repeat bg-right md:bg-contain h-[480px] md:h-[650px] lg:h-[742px] xl:block"
      >
        <div
          class="container md:relative absolute md:top-24 lg:top-[120px] xl:top-[164px]"
        >
          <div
            class="border-b-4 border-primary-500 ml-0.5 md:border-b-[6px] skew-x-[-25deg] w-[108px]"
          />

          <h1
            class="hero-title text-[34px] md:text-4xl lg:text-5xl xl:text-[56px] font-ff-good-pro-cond font-bold italic xl:tracking-[0.56px] leading-[40px] md:leading-[3rem] xl:leading-[60px] text-start text-white mt-3 md:mt-6 lg:mt-8 xl:mt-[41px] mb-0 md:max-w-[280px] lg:max-w-[350px] xl:max-w-[450px]"
            v-html="$t('common.calculate_correct_bike_size')"
          ></h1>
          <p
            class="w-[299px] text-[15px] md:text-[22px] md:leading-8 italic leading-6 md:w-[440px] xl:w-[540px] font-ff-good-pro-cond font-normal text-start text-white pt-3 lg:pt-[24px] pb-3 lg:pb-[40px]"
            v-html="$t('common.calculate_correct_bike_size_description')"
          ></p>
        </div>
      </div>

      <!-- Mobile Version Banner cover Section-->
      <div
        class="relative block bg-black lg:hidden md:hidden"
        data-aos="fade-left"
        data-aos-delay="100"
        data-aos-offset="100"
      >
        <img
          class="relative w-full h-[480px] object-cover"
          src="@/assets/images/calculate-bike-size/cbs-hero-bg-mobile.png"
          :alt="$t('common.calculate_bike_size')"
        />

        <div
          class="container md:relative md:top-0 top-auto bottom-8 md:bottom-auto pb-[60px] pt-[30px]"
        >
          <div
            class="border-b-4 skew-x-[-50deg] border-primary-500 w-[69px] md:w-[108px] h-1 lg:h-[6px] absolute md:mt-[99px] mb-[31px]"
          ></div>
          <h1
            class="hero-title text-[32px] tracking-[0.32px] gap-2 font-ff-good-pro-cond italic mb-0 font-bold w-full leading-[40px] text-white mt-[16px]"
            v-html="$t('common.calculate_correct_bike_size')"
          ></h1>
          <p
            class="text-lg font-ff-good-pro-cond font-normal w-full leading-7 italic text-start text-white pt-[12px]"
            v-html="$t('common.calculate_correct_bike_size_description')"
          />
        </div>
      </div>
    </section>
    <span id="calculate"></span>
    <CcbsCalculateYourSize
      class="wizard"
      v-if="!calculateBikeSizeStore.isCompleted"
    />
    <CcbsBikeModalResult v-else-if="calculateBikeSizeStore.isCompleted" />
  </div>
</template>

<script setup>
import { useCalculateBikeSizeStore } from "~/store/calculatebikesize";

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  secondaryTitle: {
    type: String,
    default: null,
  },
  description: {
    type: String,
    default: null,
  },
  imageUrl: {
    type: String,
    default: "dealer",
  },
});

const calculateBikeSizeStore = useCalculateBikeSizeStore();

try {
  calculateBikeSizeStore.fetchBikeModals();
} catch (error) {
  console.log(error, "error");
}
</script>
<style>
.bike-size-hero-bg-section {
  background-image: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) -5.97%,
      rgba(0, 0, 0, 0.87) 104.62%
    ),
    url("@/assets/images/calculate-bike-size/cbs-hero-bg.png");
  background-repeat: no-repeat;
  background-position: center center;
  @apply md:bg-cover;
}
.calculate-bike-size .hero-title strong {
  @apply text-primary m-0;
}
</style>
